import React, { useState } from 'react';
import './Login.css';
import { Link } from "react-router-dom";
import { bake_cookie } from 'sfcookies';
import { faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useUtils from '../utiles/useUtiles';
import SAlert from '../main/sections/shared/SAlert';
import Footer from '../main/components/Footer';
import Swal from 'sweetalert2';

const Login: React.FC = () => {
	const [email, setEmail] = useState<string>('');
	const [password, setPassword] = useState<string>('');
	const [showAlert, setShowAlert] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);
	const [showEyeIcon, setShowEyeIcon] = useState<boolean>(false);

	const { toastInstance, axiosRequest, baseUrl, loadingScreen } = useUtils();
	const toast = toastInstance();
	const axios = axiosRequest();


	function onChangeHandler(e: React.ChangeEvent<HTMLInputElement>) {
		const { name, value } = e.target;
		if (name === 'email') setEmail(value);
		if (name === 'password') setPassword(value);
	}

	async function loginUser(e: React.UIEvent) {
		try {
			e.preventDefault();
			if (email === '') {
				toast.warn('Please insert your email');
				return;
			}
			if (password === '') {
				toast.warn('Please insert your password');
				return;
			}
			setLoading(true);
			const request = await axios.post(`${baseUrl()}/auth/admin/sign_in`, { email, password });
			const { error, msg, accessToken } = request.data;
			setLoading(false);
			if (error) {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: msg,
				});
			} else {
				bake_cookie('admin_pppcalc', accessToken);
				window.location.reload();
			}

		} catch (error: any) {
			setLoading(false);
			toast.error(error.msg);
		}
	}

	return (
		<>
			<div className="container noauth-container">
				<div className="row">
					<div className="col-sm-12">
						<div className="main-container">
							<div className="logo mb-3"><img src="logo-min.png" /></div>
							<div className="main-card">
								<h1 className="text-center mb-4">Login</h1>

								<div className="mb-4">
									<label>Email</label>
									<input type="text" className="form-control" name="email" onChange={onChangeHandler} value={email} />
								</div>

								<div className="mb-4">
									<label>Password</label>
									<div className='field-icon'>
										<input type={showEyeIcon ? 'text' : 'password'} className="form-control" name="password" onChange={onChangeHandler} value={password} />
										{
											showEyeIcon ? (
												<span className='pass-field-icon' onClick={() => setShowEyeIcon(false)}>
													<FontAwesomeIcon
														color='#978f8f'
														icon={faEye}
														className="iconGray isPointer ml-2"
													/>
												</span>
											) : (
												<span className='pass-field-icon' onClick={() => setShowEyeIcon(true)}>
													<FontAwesomeIcon
														color='#978f8f'
														icon={faEyeSlash}
														className="iconGray isPointer ml-2"
													/>
												</span>
											)
										}
									</div>
									<p className="mt-1">
										<Link to='/forget-password' className="link-text">Forgot password?</Link>
									</p>
								</div>
								<div>
									<a href="#" onClick={loginUser} className="revrex-primary-btn">Sign in</a>
								</div>
							</div>

						</div>
						<Footer />
					</div>
				</div>
			</div>

			{loadingScreen(loading)}
			<SAlert
				show={showAlert}
				title="Account Deactivated"
				confirmBtnBsStyle="warning"
				confirmBtnText="Ok"
				showCancel={false}
				msg="Please contact support with mike@hitechcpa.com"
				onConfirm={() => setShowAlert(false)}
				onCancel={() => setShowAlert(false)}
			/>
		</>
	);
}

export default Login;
